module.exports = __webpack_public_path__ + "img/web-11.b6b6a54e.gif";